<!-- Background -->
<div
  class="absolute h-screen w-screen bg-cover bg-center"
  style="background-image: url('assets/woordkr8/backgrounds/login-background.png')"
></div>

<div class="barlow-semi-condensed-bold relative flex h-screen flex-col items-center justify-center">
  <!-- inner -->
  <div class="flex h-5/6 w-full flex-col justify-between md:w-4/5">
    <!-- Top text -->
    <div class="text-center text-8xl text-white">Waar wil je spelen?</div>

    <!-- Buttons -->
    <div class="mt-12 flex flex-row justify-around gap-2 px-4 md:gap-8 md:px-16">
      <app-portal-button class="h-36 w-sm transition-transform hover:scale-105" (clicked)="navigateToThuisLogin()">
        <span class="barlow-semi-condensed-bold text-6xl">Thuis</span>
      </app-portal-button>
      <app-portal-button (clicked)="navigateToSchoolActivation()" class="h-36 w-sm transition-transform hover:scale-105">
        <span class="barlow-semi-condensed-bold text-6xl">School</span></app-portal-button
      >
    </div>
  </div>
</div>
